<template>
  <el-dialog
    class="dialog-wrapper change-dilution"
    :visible="true"
    :show-close="false"
    @close="abortAction"
  >
    <ContentHeader
      slot="title"
      :title="
        $t('analysesData.changeDilution.title', {
          sample: sample.labSampleCode,
        })
      "
    />
    <ValidationObserver
      ref="operationForm"
      v-slot="{ handleSubmit, invalid }"
    >
      <el-form
        ref="form"
        label-position="top"
      >
        <FormItem :label="$t('analysesData.changeDilution.label')">
          <el-select
            v-model="dilution"
            placeholder="Select"
          >
            <el-option
              v-for="item in dilutions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </FormItem>

        <FormButtons>
          <el-button
            type="secondary"
            @click.prevent="abortAction"
          >
            {{ $t('global.cancel') }}
          </el-button>
          <el-button
            type="primary"
            native-type="submit"
            :disabled="invalid"
            @click.prevent="handleSubmit(patchDilution)"
          >
            {{ $t('analysesData.changeDilution.update') }}
          </el-button>
        </FormButtons>
      </el-form>
    </ValidationObserver>
  </el-dialog>
</template>

<script>
  import FormItem from '@/components/FormItem.vue';
  import { DILUTIONS } from '@/config/constants';
  import ContentHeader from '@/components/ContentHeader.vue';
  import FormButtons from '@/components/FormButtons.vue';
  import { samplesApi } from '@/api';

  export default {
    name: 'ChangeDilution',
    components: {
      ContentHeader,
      FormButtons,
      FormItem,
    },
    props: {
      samples: { required: true },
    },
    data() {
      return {
        dilution: '',
      };
    },
    computed: {
      sample() {
        return this.samples.length ? this.samples[0] : {};
      },
      dilutions() {
        return Object.values(DILUTIONS).map((val) => ({
          value: val,
          label: this.$t(`enums.dilutions.${val}`),
        }));
      },
    },
    methods: {
      abortAction() {
        this.$emit('dialogClose', { success: false });
      },
      async patchDilution() {
        await samplesApi.patchSample(this.sample.id, {
          dilution: this.dilution,
        });
        this.$emit('dialogClose', { success: true });
      },
    },
    created() {
      this.dilution = this.sample.dilution;
    },
  };
</script>
<style lang="scss">
  .change-dilution {
    .el-dialog {
      width: 30%;
    }
  }
</style>
